const socialLinks = [
    {
        name: 'GitHub',
        url: 'https://github.com/bhyeanhasan',
        iconClass: 'fa fa-github-square',
        color: '#24292e',
    },
    {
        name: 'LinkedIn',
        url: 'https://www.linkedin.com/in/bhyean/',
        iconClass: 'fa fa-linkedin-square',
        color: '#0077b5',
    },
    {
        name: 'YouTube',
        url: 'https://www.youtube.com/@bhyeanhasan',
        iconClass: 'fa fa-youtube-play',
        color: '#ff0000',
    },
    {
        name: 'WhatsApp',
        url: 'https://wa.me/8801920599266',
        iconClass: 'fa fa-whatsapp',
        color: '#25D366',
    },
    {
        name: 'Facebook',
        url: 'https://www.facebook.com/bhyeanhasan/',
        iconClass: 'fa fa-facebook-square',
        color: '#1877F2',
    },
    {
        name: 'X',
        url: 'https://x.com/avoid_noyon',
        iconClass: 'fa fa-twitter-square',
        color: '#14171A',
    },
    {
        name: 'Instagram',
        url: 'https://www.instagram.com/avoid_noyon/',
        iconClass: 'fa fa-instagram',
        color: '#E1306C',
    },
    {
        name: 'Blog',
        url: 'https://bhyeanhasan.blogspot.com/',
        iconClass: 'fa fa-globe',
        color: '#f39c12',
    },
];

export default socialLinks;
